import React from 'react'

import style from 'pages/FavoritesPage.module.scss'

import BarLoader from 'components/Loader/BarLoader'

import HeartEmpty from 'assets/icons/icon-heartEmpty.svg'

const FavoritesLoader: React.FC = () => {
  return (
    <div
      className={`${style.noFavoritesWrapper} ${style.noFavorites} ${style.favoritesLoader}`}
    >
      <HeartEmpty
        className={`${style.favoritesPromptHeart} ${style.emptyHeartLg}`}
        title=""
      />
      <BarLoader height={20} marginBottom={15} width={450} />
      <BarLoader height={20} marginBottom={15} width={300} />
      <BarLoader height={20} marginBottom={4} width={400} />
    </div>
  )
}
export default FavoritesLoader
